import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from './../../services/login.service';
import { CacheService } from 'src/app/services/cache.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  username: string = '';
  password: string = '';
  currentLang: string = '' ;
  constructor(private loginService: LoginService, private toastrService: ToastrService, private router: Router,
    public translate: TranslateService,
    private cacheService: CacheService) {
  }

  ngOnInit(): void {
    if (this.cacheService.getItem('locale') && (this.cacheService.getItem('locale') != null || this.cacheService.getItem('locale') != 'null')) {
      console.log(localStorage.getItem('locale'));
      const browserLang = this.cacheService.getItem('locale');
      this.translate.use(browserLang);
      this.currentLang=this.translate.currentLang;
    } else {
      this.translate.use('en');
      this.currentLang='en';
    }
  }

  login() {

    if (this.username && this.password) {

      this.loginService.authenticatWithLdap(this.username, this.password).subscribe(response => {
        if (response === null) {
          this.cacheService.setItem("username",this.username );
          this.cacheService.setItem("isUserAuthenticated",true);
          this.router.navigate(["home"]);

        }
      }, error => {
        if (error && error.status && (error.status === 400)) {
          if (error['message'] === 'dimbo.i18.api.error.ldap.failed') {
            this.toastrService.warning(this.translate.instant(error['message']), this.translate.instant('dmbr-bo.i18n.message.toastr.error'), { closeButton: true, });   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          }
          else if (error['message'] === 'dimbo.i18.api.error.username.missing') {
            this.toastrService.warning(this.translate.instant(error['message']), this.translate.instant('dmbr-bo.i18n.message.toastr.error'), { closeButton: true, });   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          }
          else if (error['message'] === 'dimbo.i18.api.error.usernameandpassword.missing') {
            this.toastrService.warning(this.translate.instant(error['message']), this.translate.instant('dmbr-bo.i18n.message.toastr.error'), { closeButton: true, });   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          }
          else if (error['message'] === 'dimbo.i18.api.error.password.missing') {
            this.toastrService.warning(this.translate.instant(error['message']), this.translate.instant('dmbr-bo.i18n.message.toastr.error'), { closeButton: true, });   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          }

          else {
            this.toastrService.warning(this.translate.instant(error['message']), this.translate.instant('dmbr-bo.i18n.message.toastr.warning'), { closeButton: true, });
          }
        } else {
          this.toastrService.error(this.translate.instant('dmbr-bo.i18n.message.record.error'), this.translate.instant('dmbr-bo.i18n.message.toastr.error'), { closeButton: true, });   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        }
        this.username = '';
        this.password = '';
      })
    } else {
      this.toastrService.warning(this.translate.instant('dmbr-bo.i18n.message.login.credential.empty'), this.translate.instant('dmbr-bo.i18n.message.toastr.warning'), { closeButton: true, });  //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
    }

  }

  changeLang(language: string) {
    this.cacheService.setItem('locale', language);
    this.translate.use(language);
  }

}
